import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import SiteBreadcrumb from "../../../components/Common/Breadcumb";
import OffWrap from "../../../components/Layout/Header/OffWrap";
import Footer from "../../../components/Layout/Footer/FooterStyleOne";
import SearchModal from "../../../components/Layout/Header/SearchModal";
import ScrollToTop from "../../../components/Common/ScrollTop";
import Newsletter from "../../../components/Common/Newsletter";
import Header from "../../../components/Layout/Header/Header";
import { Link } from "react-router-dom";
import { FaMobileAlt, FaApple, FaAndroid, FaReact, FaShieldAlt, FaRocket, FaUsers, FaChartLine } from "react-icons/fa";

import bannerbg from "../../../assets/img/breadcrumbs/sssss.jpg";
import Logo from "../../../assets/img/logo/dark-logo.png";
import footerLogo from "../../../assets/img/logo/lite-logo.png";
import favIcon from "../../../assets/img/fav.png";
import IndustriesSection from "../../home/IndustriesSection";

const services = [
    { icon: FaApple, title: "iOS App Development", description: "Native Swift/SwiftUI apps optimized for the Apple ecosystem." },
    { icon: FaAndroid, title: "Android App Development", description: "High-performance Kotlin apps compatible across diverse devices." },
    { icon: FaReact, title: "Cross-Platform Development", description: "Cost-effective React Native and Flutter solutions for both platforms." },
    { icon: FaShieldAlt, title: "Secure & Scalable Architecture", description: "Enterprise-grade encryption and scalable user architecture." },
    { icon: FaRocket, title: "App Store Optimization & Launch", description: "Complete optimization, submission, and launch strategy." },
    { icon: FaUsers, title: "User-Centric Design", description: "Intuitive interfaces driven by user research and testing." },
    { icon: FaChartLine, title: "Analytics & Performance Monitoring", description: "Integrated tracking for actionable performance insights." },
    { icon: FaMobileAlt, title: "Offline-First Capabilities", description: "Smart caching for productivity without internet connectivity." },
];

const MobileAppDevelopment = () => {
    const [isVisible, setIsVisible] = useState({});

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsVisible((prev) => ({ ...prev, [entry.target.id]: true }));
                    }
                });
            },
            { threshold: 0.1 }
        );

        services.forEach((_, index) => {
            const element = document.getElementById(`service-${index}`);
            if (element) observer.observe(element);
        });

        return () => observer.disconnect();
    }, []);

    return (
        <React.Fragment>
            <Helmet>
                <link rel="icon" href={favIcon} />
                <title>Mobile App Development - Syrol Tech</title>
                <meta name="description" content="We design and build secure, high-performance mobile applications for Android and iOS, engineered for scalability, reliability, and exceptional user experience." />
            </Helmet>
            <OffWrap />
            <Header
                parentMenu="pages"
                secondParentMenu="others"
                headerNormalLogo={Logo}
                headerStickyLogo={Logo}
                CanvasLogo={Logo}
                mobileNormalLogo={Logo}
                CanvasClass="right_menu_togle hidden-md"
                headerClass="full-width-header header-style1 home8-style4"
                TopBar="enable"
                TopBarClass="topbar-area home8-topbar"
                emailAddress="hello@syroltech.com"
                Location="Abuja, Nigeria"
            />
            <SiteBreadcrumb
                pageTitle="Mobile App Development"
                pageName="Mobile App Development"
                breadcrumbsImg={bannerbg}
            />

            {/* Hero Section with Banner Image and Brand Color Overlay */}
            <section style={{
                backgroundImage: `url(${bannerbg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                padding: '100px 0',
                position: 'relative',
                overflow: 'hidden'
            }}>
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'rgba(0, 0, 0, 0.55)',
                    zIndex: 1
                }}></div>

                <div className="container" style={{ position: 'relative', zIndex: 2 }}>
                    <div className="row align-items-center">
                        <div className="col-lg-8 mx-auto text-center">
                            <div style={{ animation: 'fadeInUp 0.8s ease-out' }}>
                                <FaMobileAlt style={{ fontSize: '80px', color: '#ffc107', marginBottom: '30px', animation: 'float 3s ease-in-out infinite', filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.3))' }} />
                                <h1 style={{ color: '#fff', fontWeight: 800, fontSize: '3.5rem', marginBottom: '25px', lineHeight: 1.2, textShadow: '0 2px 10px rgba(0,0,0,0.3)' }}>
                                    Mobile App Development
                                </h1>
                                <p style={{ color: 'rgba(255,255,255,0.95)', fontSize: '1.3rem', maxWidth: '700px', margin: '0 auto 40px', lineHeight: 1.6 }}>
                                    Secure, high-performance Android and iOS apps designed for scalability and user experience.
                                </p>
                                <Link to="/book-meeting" style={{
                                    display: 'inline-block',
                                    padding: '18px 45px',
                                    background: '#ffc107',
                                    color: '#202020',
                                    borderRadius: '50px',
                                    fontWeight: 700,
                                    fontSize: '1.1rem',
                                    textDecoration: 'none',
                                    boxShadow: '0 10px 30px rgba(255, 193, 7, 0.4)',
                                    transition: 'all 0.3s ease',
                                    border: 'none'
                                }}
                                    onMouseEnter={(e) => {
                                        e.target.style.transform = 'translateY(-3px)';
                                        e.target.style.boxShadow = '0 15px 40px rgba(255, 193, 7, 0.6)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = 'translateY(0)';
                                        e.target.style.boxShadow = '0 10px 30px rgba(255, 193, 7, 0.4)';
                                    }}>
                                    Get Started Today
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Services Grid with Staggered Animation */}
            <section style={{ padding: '100px 0', background: '#f8f9fa' }}>
                <div className="container">
                    <div className="text-center mb-5">
                        <h2 style={{ fontSize: '2.8rem', fontWeight: 800, color: '#202020', marginBottom: '20px' }}>
                            Our Mobile App Development Services
                        </h2>
                        <div style={{ width: '80px', height: '4px', background: '#ffc107', margin: '0 auto' }}></div>
                    </div>

                    <div className="row g-4">
                        {services.map((service, index) => {
                            const Icon = service.icon;
                            return (
                                <div key={index} className="col-lg-6 col-md-6" id={`service-${index}`}>
                                    <div className={`service-card-${index}`} style={{
                                        background: '#fff',
                                        borderRadius: '20px',
                                        padding: '40px',
                                        height: '100%',
                                        boxShadow: '0 5px 20px rgba(0,0,0,0.08)',
                                        transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
                                        opacity: isVisible[`service-${index}`] ? 1 : 0,
                                        transform: isVisible[`service-${index}`] ? 'translateY(0)' : 'translateY(30px)',
                                        transitionDelay: `${index * 0.1}s`,
                                        position: 'relative',
                                        overflow: 'hidden',
                                        border: '2px solid rgba(0,0,0,0.05)',
                                        cursor: 'pointer'
                                    }}
                                        onMouseEnter={(e) => {
                                            const card = e.currentTarget;
                                            const iconBox = card.querySelector('.icon-box');
                                            const icon = card.querySelector('.service-icon');
                                            const decorCircle = card.querySelector('.decor-circle');

                                            card.style.transform = 'translateY(-15px) scale(1.02)';
                                            card.style.boxShadow = '0 25px 50px rgba(255, 193, 7, 0.25)';
                                            card.style.borderColor = '#ffc107';
                                            card.style.background = 'linear-gradient(135deg, #fff 0%, #fffbf0 100%)';

                                            if (iconBox) {
                                                iconBox.style.transform = 'scale(1.1) rotate(5deg)';
                                                iconBox.style.background = '#202020';
                                                iconBox.style.boxShadow = '0 15px 35px rgba(255, 193, 7, 0.5)';
                                            }
                                            if (icon) {
                                                icon.style.color = '#ffc107';
                                            }
                                            if (decorCircle) {
                                                decorCircle.style.background = 'rgba(255, 193, 7, 0.15)';
                                                decorCircle.style.transform = 'scale(1.5)';
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            const card = e.currentTarget;
                                            const iconBox = card.querySelector('.icon-box');
                                            const icon = card.querySelector('.service-icon');
                                            const decorCircle = card.querySelector('.decor-circle');

                                            card.style.transform = 'translateY(0) scale(1)';
                                            card.style.boxShadow = '0 5px 20px rgba(0,0,0,0.08)';
                                            card.style.borderColor = 'rgba(0,0,0,0.05)';
                                            card.style.background = '#fff';

                                            if (iconBox) {
                                                iconBox.style.transform = 'scale(1) rotate(0deg)';
                                                iconBox.style.background = '#ffc107';
                                                iconBox.style.boxShadow = '0 10px 25px rgba(255, 193, 7, 0.3)';
                                            }
                                            if (icon) {
                                                icon.style.color = '#202020';
                                            }
                                            if (decorCircle) {
                                                decorCircle.style.background = 'rgba(255, 193, 7, 0.05)';
                                                decorCircle.style.transform = 'scale(1)';
                                            }
                                        }}>
                                        <div className="decor-circle" style={{
                                            position: 'absolute',
                                            top: 0,
                                            right: 0,
                                            width: '150px',
                                            height: '150px',
                                            background: 'rgba(255, 193, 7, 0.05)',
                                            borderRadius: '0 0 0 100%',
                                            transition: 'all 0.5s ease'
                                        }}></div>

                                        <div style={{ position: 'relative', zIndex: 1 }}>
                                            <div className="icon-box" style={{
                                                width: '70px',
                                                height: '70px',
                                                background: '#ffc107',
                                                borderRadius: '15px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                marginBottom: '25px',
                                                boxShadow: '0 10px 25px rgba(255, 193, 7, 0.3)',
                                                transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)'
                                            }}>
                                                <Icon className="service-icon" style={{
                                                    fontSize: '32px',
                                                    color: '#202020',
                                                    transition: 'all 0.5s ease'
                                                }} />
                                            </div>

                                            <h3 style={{
                                                fontSize: '1.5rem',
                                                fontWeight: 700,
                                                color: '#202020',
                                                marginBottom: '15px',
                                                transition: 'color 0.3s ease'
                                            }}>
                                                {service.title}
                                            </h3>

                                            <p style={{
                                                color: '#505050',
                                                fontSize: '1rem',
                                                lineHeight: 1.7,
                                                margin: 0
                                            }}>
                                                {service.description}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>

            <IndustriesSection />
            <Newsletter
                sectionClass="rs-newsletter style1 orange-color event-bg mb--90 sm-mb-0 sm-pb-80"
                titleClass="title mb-0 white-color"
            />
            <Footer
                footerClass="rs-footer home9-style main-home"
                footerLogo={footerLogo}
            />
            <SearchModal />
            <ScrollToTop scrollClassName="scrollup orange-color" />

            <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes float {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-20px);
          }
        }

        @media (max-width: 991px) {
          h1 {
            font-size: 2.5rem !important;
          }
          p {
            font-size: 1.1rem !important;
          }
        }

        @media (max-width: 767px) {
          h1 {
            font-size: 2rem !important;
          }
          p {
            font-size: 1rem !important;
          }
        }
      `}</style>
        </React.Fragment >
    );
};

export default MobileAppDevelopment;
